<template>
    <div class="spotlight-result-item" :class="{ 'spotlight-result-item--focused': focused }" @click="$emit('select', item)">
        <div class="spotlight-result-icon spotlight-result-icon--agenda">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
        </div>
        <div class="spotlight-result-text">
            <div class="spotlight-result-title">{{ item.title }}</div>
            <div v-if="item.subtitle" class="spotlight-result-subtitle">{{ formattedSubtitle }}</div>
        </div>
        <div class="spotlight-result-meta">
            <span v-if="status" class="spotlight-status-badge" :class="'spotlight-status--' + statusClass">{{ status.label }}</span>
            <span v-if="sharedBy" class="spotlight-shared-by">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                {{ sharedBy }}
            </span>
        </div>
    </div>
</template>

<script>
const AGENDA_STATUS_CLASS = {
    1: 'pending',
    2: 'completed',
    3: 'cancelled',
}

export default {
    name: 'AgendaResult',
    props: { item: Object, focused: Boolean },
    emits: ['select'],
    computed: {
        formattedSubtitle() {
            const sub = this.item.subtitle
            if (!sub) return ''
            const formats = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD']
            const start = this.$moment(sub, formats, true)
            if (!start.isValid()) return sub

            const endRaw = this.item.meta?.event_end_at
            const end = endRaw ? this.$moment(endRaw, formats, true) : null

            const hasStartTime = sub.includes(':')
            const hasEndTime = endRaw?.includes(':')

            if (!end || !end.isValid()) {
                return hasStartTime ? start.format('D MMMM YYYY, HH:mm') : start.format('D MMMM YYYY')
            }

            const sameDay = start.isSame(end, 'day')
            if (sameDay) {
                if (hasStartTime && hasEndTime) return start.format('D MMMM YYYY, HH:mm') + ' - ' + end.format('HH:mm')
                return start.format('D MMMM YYYY')
            }

            if (start.isSame(end, 'year')) {
                const s = start.format(hasStartTime ? 'D MMMM HH:mm' : 'D MMMM')
                const e = end.format(hasEndTime ? 'D MMMM HH:mm' : 'D MMMM')
                return s + ' - ' + e + ', ' + end.format('YYYY')
            }

            const startStr = start.format(hasStartTime ? 'D MMMM YYYY, HH:mm' : 'D MMMM YYYY')
            const endStr = end.format(hasEndTime ? 'D MMMM YYYY, HH:mm' : 'D MMMM YYYY')
            return startStr + ' - ' + endStr
        },
        status() {
            return this.item.meta?.status || null
        },
        statusClass() {
            return AGENDA_STATUS_CLASS[this.status?.id] || 'pending'
        },
        sharedBy() {
            return this.item.meta?.shared_by?.name || null
        }
    }
}
</script>
